module.exports = __webpack_public_path__ + "static/media/3_Heaven and hell_JP.4f9f52d8.txt";